<script>
    import { navigateTo } from 'svelte-router-spa'
    import { temp } from '../../store.js'

    function nxt(myTemp) {
        temp.set(myTemp)
        navigateTo('symptom')
    }

    let formLink = "https://share.hsforms.com/1HFKFFJkKRTSZ_WTIhQVSFw4lq3k"
    let showVideo = Math.random() <= 0.5;
</script>

<main>
    <div class="body">
        <h1>Input your Temperature</h1>
        <p>Ilagay ang iyong temperatura</p>
        <div class="temp">
            <input type="text" bind:value={$temp}>
            <span class="unit">°C</span>
        </div>

        <div class="buttons">
            {#if $temp}
            <a class="btn btn-primary" on:click={() => nxt($temp)}>Next</a>
            {/if}

            <a class="btn" on:click={() => nxt('N/A')}>Skip</a>
        </div>
    </div>

    <div class="ad">
        {#if showVideo === true}
        <div class='embed-container'>
            <iframe src='https://www.youtube.com/embed/J0AKdyBuZzI' frameborder='0' allowfullscreen></iframe>
        </div>
        {/if}

        <h2>Staying health secure starts at home</h2>
        <p>Learn more about the SEQu-HEALTH Pro Bluetooth Thermometer and Enhanced Daily Health Declaration companion app</p>
        <a class="btn btn-primary" href={formLink} target="_blank">Download our brochure</a>
        
        {#if showVideo === false}
        <a href={formLink} target="_blank">
            <img src="../img/health-pro.png" alt="Download SEQu-HEALTH Pro Brochure"/>
        </a>
        {/if}
    </div>
</main>

<style>
input {
    width: 50% !important;
}

.ad {
    padding: 8%;
    background: #fafafa;
    border: solid 1px #969696;
    margin-top: 24px;
    margin-bottom: 24px;
}

.ad>a>img {
    width: 100%;
    margin-top: 24px;
}

.embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    background: #969696;
}

.embed-container iframe, .embed-container object, .embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>